//@flow
import React, { Component } from 'react';
import type { Match } from 'react-router-dom';
import SVG from 'react-svg-inline';
import { connect } from 'react-redux';
import hiverLogo from '../../../common/images/hiverLogo.svg'
import countryCodes from '../../../common/assets/countryCodes';
import {
    getUserCountryCode,
    getSignupURL,
    submitCustomerDetails,
    getCookie
} from './utils'
import {
    AppLogo,
    CTAButton,
    TextField,
    SelectInput,
    validateEmail,
    validatePhone,
    validateRequired,
    validateMaxLength,
    validateForm,
    SETUP_STATES,
    config
} from 'h-signup';
import {
    Root,
    MainSection,
    FormSection,
    FlauntSection,
    FormTitle,
    FormSubTitle,
    FlauntElements,
    FlauntTitle,
    Footer,
    RefreshButton,
    PartnerIcon
} from './styledComponents';

class SignUp extends Component<Props, State> {

    styles: Object = {
        spinner: {
            color: '#fff'
        }
    }
    constructor(props: Props) {
        super(props);
        this.state = {
            email: {
                ref: null, value: ''
            },
            phoneNumber: {
                ref: null, value: ''
            },
            name: {
                ref: null, value: ''
            },
            isdCode: '',
            codesMap: {},
            countryCode: '',
            submitInProgress: false,
            submitError: false
        }
    }


    async componentDidMount() {
        const codesMap: CodeMap = countryCodes.reduce((agg, curr) => {
            return { ...agg, [curr.countryCode]: { name: curr.name, label: `${curr.isdCode} - ${curr.name}`, value: curr.isdCode } };
        }, {});
        try {
            const countryCode = await getUserCountryCode();
            if (codesMap[countryCode]){
                const { value } = codesMap[countryCode];
                this.setState({
                    countryCode,
                    codesMap,
                    isdCode: value
                });
            }
        } catch(e) {
            console.error(e);
        }
        this.syncSetupStateToRoute();
    }

    syncSetupStateToRoute() {
		const { progress, history } = this.props;
		if (progress > -1)
			history.push(`/${SETUP_STATES[0]}`);
	}
    getValidationObjects(){
        const required = {
            func: validateRequired,
            error: 'This is required'
        };
        const email = {
            func: validateEmail,
            error: 'Please enter a valid email address'
        }
        const phone = {
            func: validatePhone,
            error: 'Please enter a valid phone number'
        }
        const validateNameLength = {
            func: validateMaxLength(120),
            error: 'Please enter an input of maximum 120 characters'
        }
        return {
            required, email, phone, validateNameLength
        }
    }

    updateField = (value: string, target: string) => {
        this.setState({
            [target]: {
                ref: this.state[target].ref,
                value
            }
        })
    }

    updateCountryCode = (event: any) => {
        this.setState({
            isdCode: event.target.value
        })
    }

    updateRef = (ref: any, target: string) => {
        this.setState({
            [target]: {
                ref,
                value: this.state[target].value
            }
        })
    }

    handleSubmit = async (event: SyntheticEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { submitInProgress } = this.state;
        if (submitInProgress) return;
        const validMap = {
            email: false, phoneNumber: false, name: false
        }
        const formValid = await validateForm(validMap, this.state, 3);
        if (!formValid)
            return;
        const { email, name, phoneNumber, countryCode, codesMap } = this.state;
        this.setState({
            submitInProgress: true
        }, () => {
            getSignupURL(email.value.trim())
            .then(this.handleRedirect)
            .catch((e) => {
                this.setState({
                    submitError: e,
                    submitInProgress: false
                })
            });
            const customerDetails = {
                name: name.value.trim(),
                email: email.value.trim(),
                phone: phoneNumber.value.trim(),
                country: codesMap[countryCode].name,
                submitUrl: window.location.href,
                hubspotutk: getCookie('hubspotutk')
            }
            submitCustomerDetails(customerDetails);
        });
    }
    handleRedirect = (data: Object) => {
        const { msg, msgtype: msgType, redirect_url } = data;
        if (msgType !== 'error' && redirect_url) {
            setTimeout(() => window.location = redirect_url, 333);
        } else {
            this.setState(state => {
                let change = { submitInProgress: false };
                if (msgType === 'error')
                    change = { ...change, submitError: msg }
                return {
                    ...state,
                    ...change
                }
            });
        }

    }


    renderError() {
        const refresh = () => window.location.reload();
        return <FormSection>
                <FormTitle>
                    Oops, Something terrible happened!
                </FormTitle>
                <FormSubTitle>
                    Please refresh the page and try again.
                </FormSubTitle>
                <RefreshButton onClick={refresh}>
                    <SVG
                        height="15px"
                        svg={require('../../../common/images/refresh-icon.svg')}
                    />
                    <span className="txt">Refresh</span>
                </RefreshButton>
        </FormSection>

    }

    renderForm() {
        const { required, email, phone, validateNameLength} = this.getValidationObjects();
        const { submitInProgress, isdCode } = this.state;
        const codesMap: CodeMap = this.state.codesMap;
        const selectData = Object.values(codesMap)
            .map((d: any) => d)
            .sort((a, b) => a.name.localeCompare(b.name));
        return <FormSection onSubmit={this.handleSubmit}>
            <FormTitle>Sign up for free 14 day trial</FormTitle>
            <FormSubTitle>No credit card required</FormSubTitle>
            <TextField label="Full Name"
                validations={[required, validateNameLength]}
                innerRef={(ref => this.updateRef(ref, 'name'))}
                onChange={(value) => this.updateField(value, 'name')}
            />
            <TextField label="Phone Number"
                validations={[required, phone]}
                innerRef={(ref => this.updateRef(ref, 'phoneNumber'))}
                onChange={(value) => this.updateField(value, 'phoneNumber')}
            >
                <SelectInput
                    data={selectData}
                    value={isdCode}
                    onChange={this.updateCountryCode} />
            </TextField>
            <TextField label="G Suite / Gmail account"
                validations={[required, email]}
                innerRef={(ref => this.updateRef(ref, 'email'))}
                onChange={(value) => this.updateField(value, 'email')}
            />
            <CTAButton isLoading={submitInProgress} type="submit">
                Get Started
            </CTAButton>
            <PartnerIcon
                src={require('../../images/partner@2x.png')}
            />
        </FormSection>
    }

    renderFlaunt() {
        return <FlauntSection>
            <FlauntElements>
                <img
                    className="flaunt-chrome-store"
                    src={require('../../images/chromeStore@2x.png')}
                />
                <FlauntTitle>
                    Loved by customers across 30+ countries
                </FlauntTitle>
                <img
                    className="flaunt-customers"
                    src={require('../../images/customers@2x.png')}
                />
                <SVG
                    className="flaunt-arc"
                    svg={require('../../images/signup-arc.svg')}
                />
            </FlauntElements>
        </FlauntSection>
    }

    render() {
        const { submitError } = this.state;
        const termsUrl = config.LANDING_ROOT_URL + '/terms';
        const privacyUrl = config.LANDING_ROOT_URL + '/privacy';
        return <Root>
            <AppLogo href={config.LANDING_ROOT_URL} target="_blank">
                <SVG height="50px" svg={hiverLogo} />
            </AppLogo>
            <MainSection>
                { submitError && this.renderError() }
                { !submitError && this.renderForm() }
                { this.renderFlaunt() }
            </MainSection>
            <Footer>
                By clicking “Get Started” you agree to our <a href={termsUrl} target="_blank">Terms</a> and
                that you have read our <a href={privacyUrl} target="_blank">Privacy Policy</a>
            </Footer>
        </Root>
    }
}

type CodeMap = {
    [countryCode: string]: any
}

type Props = {
    match: Match,
    history: Object,
    progress: number
}

type TextFieldType = {
    ref: Component<any, any> | null,
    value: string
}

type State = {
    email: TextFieldType,
    phoneNumber: TextFieldType,
    name: TextFieldType,
    isdCode: string,
    codesMap: CodeMap,
    countryCode: string,
    submitInProgress: boolean,
    submitError: any
}

const mapStateToProps = ({ signUp: { progress } }) => ({
	progress
})


export default connect(mapStateToProps)(SignUp);